import React, { useState }  from "react";
import { Switch, FormControlLabel, styled } from "@mui/material";
import { Container, Box, Typography, Button, TextField, Card, CardContent, Dialog } from '@mui/material';
import UserCard from "./UserCard";
import { ReactComponent as DirectionIcon} from '../../Direction.svg'
import DialogTitle from '@mui/material/DialogTitle';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';

const MainPage = ({privateMode, userData,setUserInfo, setUserBox}) => {
  const [privacyLog, setPrivacyLog] = useState(true)
  const [dialog, setDialog] = useState(false)
  const handleDismiss = () => {
    setPrivacyLog(false)
  }

  const handleClose = () => {
    setDialog(false);
  };

  const handleOpen = ()=>{
    setDialog(true)
  }

  return (
    <>
      {!privateMode && 
      <Container maxWidth="sm" disableGutters sx={{padding: 0}}>
        <Card sx={{ padding: '8px', borderRadius: 4, backgroundColor: '#BADAFB', borderWidth: '0px', boxShadow: 'none'  }}>
          <CardContent sx={{ padding: '16px !important' }}>
            <Typography variant="h6" sx={{ fontSize: '24px', fontWeight: 800, fontFamily: '"Sora", sans-serif', letterSpacing: '-2%' }}>
              You’re on private
            </Typography>
            <div style={{ marginTop: '6px' }}>
              <Typography variant="body2" sx={{fontSize: '16px', fontWeight: 500, fontFamily: 'Manrope, sans-serif', letterSpacing: '-2%'}}>
                Switch your app to Public using the toggle above so that you can view nearby users, and they can see you, too.
              </Typography>
            </div>
          </CardContent>
        </Card>
      </Container>}
      {privateMode && privacyLog && <Container maxWidth="sm" disableGutters sx={{padding: 0, marginBottom: '20px'}}>
        <Card sx={{ p: 2, borderRadius: 4, backgroundColor: '#F7F3ED', boxShadow: 'none'  }}>
          <CardContent sx={{ paddingBottom: '0px !important' }}>
            <Typography variant="h6" sx={{ fontWeight: 'bold', fontSize: '24px', lineHeight: '100%', fontWeight: 800, fontFamily: 'Sora, sans-serif', letterSpacing: '-2%'  }}>
              Your privacy is our top priority
            </Typography>
            <div style={{ marginTop: '1rem' }}>
              <Typography variant="body2" sx={{fontSize: '16px', fontWeight: 500, fontFamily: 'Manrope, sans-serif', letterSpacing: '-2%'}}>
                Add any address to your private zones, and we’ll automatically switch you to private whenever you’re within 1km of that location.
              </Typography>
            </div>
            <Box display="flex" justifyContent="left">
              <Button variant="contained" onClick={handleOpen} sx={{width: '181px', height: '37px', backgroundColor: '#1C3DFF', borderRadius: '8px', marginTop: '14px', marginBottom: '5px', fontWeight: 400, textTransform: "none", fontSize: '15px', boxShadow: 'none',}} endIcon={<DirectionIcon />}>Add Private Zone</Button>
            </Box>
            <Box display="flex" justifyContent="left" mt={1}>
              <Button
                variant="text"
                sx={{ 
                  textDecoration: "underline",
                  textTransform: "none",
                  color: "#1C38F1",
                  fontSize: '15px',
                  fontWeight: 400
                }}
                onClick={() => handleDismiss()}
              >
                Dismiss
              </Button>
            </Box>
          </CardContent>
        </Card>
      </Container>}
      <div
        style={{
          display: 'flex',
          flexWrap: 'wrap',
          gap: '10px',
          justifyContent: 'space-around',
          marginTop: privateMode ? '0px' : '30px',
          marginBottom: '12%'
        }}
      >
        {userData && userData.length > 0 ? (
          userData.map((user) => <UserCard key={user.id} user={user} publicMode={privateMode} setUserInfo={setUserInfo} setUserBox={setUserBox}/>)
        ) : (
          <p>No users available</p>
        )}
      </div>
      <Dialog
        open={dialog}
        onClose={handleClose}
        sx={{ 
          '& .MuiPaper-root': { 
            borderRadius: '16px' 
          } 
        }}
      >
        <DialogTitle 
          id="alert-dialog-title" 
          sx={{ textAlign: 'center', color: '#1C38F1', fontSize: '18px', fontWeight: 700, fontFamily: 'Manrope, sans-serif' }}
        >
          Notice Message
        </DialogTitle>
        <DialogContent>
          <DialogContentText 
            id="alert-dialog-description" 
            sx={{ fontSize: '16px', fontWeight: 400, fontFamily: 'Manrope, sans-serif', color: '#000' }}
          >
            Please download the application to view the details
          </DialogContentText>
        </DialogContent>
        <DialogActions sx={{justifyContent: "center"}}>
          <Box display="flex" justifyContent="center">
            <Button variant="contained" onClick={handleClose} sx={{width: '304px', height: '41px', backgroundColor: '#1C3DFF', borderRadius: '8px', marginBottom: '14px', fontWeight: 400, textTransform: "none", fontSize: '16px', boxShadow: 'none',}}>Close</Button>
          </Box>
        </DialogActions>
      </Dialog>
    </>

  );
};

export default MainPage;
